import React from "react";
const ExpandMoreIcon = ({
  ...rest
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "angle-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2356 6.43917C11.1077 6.30676 10.8967 6.3031 10.7643 6.43099L7.99999 9.19535L5.23563 6.43103C5.10648 6.30627 4.90169 6.30627 4.7725 6.43103C4.64009 6.55892 4.63643 6.76994 4.76432 6.90234L7.76432 9.90234C7.82674 9.96497 7.91157 10.0001 7.99999 10C8.08841 10.0001 8.17321 9.96497 8.23563 9.90234L11.2356 6.90234C11.3604 6.77315 11.3604 6.56836 11.2356 6.43917Z",
    fill: "#004FFF"
  })));
};
export default ExpandMoreIcon;